module.exports = __webpack_public_path__ + "img/avatar.ef5235cb.png";